import { render, staticRenderFns } from "./contract-tpl.vue?vue&type=template&id=83af9478&scoped=true"
import script from "./contract-tpl.vue?vue&type=script&lang=js"
export * from "./contract-tpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83af9478",
  null
  
)

export default component.exports